import { CountryCountryI18nAllData } from '@common/master';
import { AirportI18n } from '../master/airport_i18n_all';
import { CountryI18nBy2LetterCodes } from '../master/country_i18n_by2lettercode';
import { MListData } from '../master/m_listdata';
import { MMileageProgramI18n } from '../master/m_mileage_program_i18n';

export interface MasterDataPassenger {
  mCountry?: CountryI18nBy2LetterCodes;
  mMileageProgramI18N?: MMileageProgramI18n[];
  airportI18nAll?: AirportI18n;
  mListData?: MListData[];
  mCountryI18N?: CountryCountryI18nAllData[];
}

export namespace ServiceStatusTraveler {
  export type ServiceStatusTravelerEnum = 'applied' | 'cancelled' | 'requesting';
  export const ServiceStatusTravelerEnum = {
    Applied: 'applied' as ServiceStatusTravelerEnum,
    Cancelled: 'cancelled' as ServiceStatusTravelerEnum,
    Requesting: 'requesting' as ServiceStatusTravelerEnum,
  };
}

export interface IDeduplicatedPhones {
  id: string;
  number: string;
  encryptedNumber: string;
  isSameAsRepresentative: boolean;
}

export interface PhoneSecondContract {
  number: string;
  encryptedNumber: string;
}

export interface DeduplicatedSecondContact {
  phones: PhoneSecondContract;
  ownerOfPhone: string;
}

export type MasterDataPassengerScreen = [
  any,
  [CountryI18nBy2LetterCodes, MMileageProgramI18n[], AirportI18n, MListData[], CountryCountryI18nAllData[]]
];

export interface PassengerEmail {
  id?: string;
  address?: string;
  encryptedAddress?: string;
  isSameAsRepresentative?: boolean;
}

export interface PassengerContactEmail {
  id?: string;
  address?: string;
  encryptedAddress?: string;
}
